// Version : 0.0.1
// Author : VISHAL BHARATHI
// CREATED DATA: 18-09-2025

import { docodeHexResponse } from '../../_common/common.utils';
import TransferFunderActionTypes from './transfer-funder.types';

const INITIAL_STATE = {
	// UPDATE TRANSFER FUNDER RESPONSE
	updateTransferFunderDetailsResponse: null,
	// FETCH ALL LOAN INDEX LIST FOR GROUP RESPONSE
	fetchAllLoanIndexListForGroupResponse: null,
	fetchAllLoanIndexListForGroupArr: [],
};

const transferFunderReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** UPDATE TRANSFER FUNDER DETAILS START *********************** */
		case TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_SUCCESS:
			return { ...state, updateTransferFunderDetailsResponse: action.payload };

		case TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_FAILURE:
			return { ...state, updateTransferFunderDetailsResponse: action.payload };

		case TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateTransferFunderDetailsResponse: null };
		/** ***************** UPDATE TRANSFER FUNDER DETAILS END *********************** */

		/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP START *********************** */
		case TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_SUCCESS:
			return {
				...state,
				fetchAllLoanIndexListForGroupResponse: action.payload,
				fetchAllLoanIndexListForGroupArr: docodeHexResponse(
					action.payload,
					'FetchAllLoanIndexListForGroupKey',
				),
			};

		case TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_FAILURE:
			return { ...state, fetchAllLoanIndexListForGroupResponse: action.payload };

		case TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_RESPONSE_CHANGED:
			return { ...state, fetchAllLoanIndexListForGroupResponse: null };
		/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP END *********************** */

		default:
			return state;
	}
};

export default transferFunderReducer;
